export default "__VITE_ASSET__CQ4c5fpw__"